/**
 * Created by mukund on 7/24/17.
 */

angular.module('mediacloudApp')
    .directive('zoomPublisher', ['$rootScope', '$state', '$timeout', '$filter', 'CollectionService', 'BaseFileService', 'BatchService', 'UploadErrors', 'SearchService', 'SchedulerService', function($rootScope, $state, $timeout, $filter, CollectionService, BaseFileService, BatchService, UploadErrors, SearchService, SchedulerService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/zoom-publisher/zoom-publisher.html',
            scope: {
                zoomfile: '=',
                batches: '=',
                account: '='
            },
            link: function (scope, element, attrs) {

                if (scope.account) {

                    var origin;

                    // For pagination
                    scope.collectionsPerPage = 10;
                    scope.currentPage = 1;
                    scope.collectionPath = '';
                    scope.collectionTitle = '';
                    scope.destinationCollectionIdChanged = false;

                    scope.closeFolderSelectionModal = function () {
                        scope.selectedFolder = null;
                        $('#zoomPublishWindow').modal('hide');
                    };

                    // TODO refactor if possible
                    var getChildFolders = function (pcid, $event) {
                        // Reset pagination every time we load a new level of children
                        scope.currentPage = 1;
                        if (pcid === '101') {
                            CollectionService.GetAllCollections.get({type: 'COURSE', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '100') {
                            CollectionService.GetAllCollections.get({type: 'CHANNEL', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '104') {
                            CollectionService.GetAllCollections.get({type: 'PROTECTED', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else {
                            CollectionService.GetCollectionContent.get({
                                cid: pcid,
                                fol: true,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                limit: scope.collectionsPerPage
                            }, function (result) {
                                if (result.contents && result.contents.length > 0) {
                                    showChildFolders(result.contents, $event);
                                    scope.expandedFolder.totalCollections = result.totalContents;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        }
                    };

                    scope.loadMoreFolders = function(){
                        scope.showSpinner = true;
                        scope.currentPage++;

                        if(scope.searchEnabled){

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                scope.showSpinner = false;
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = scope.childFolders.concat(result.collections);
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                            });

                        } else {
                            var parent = scope.expandedFolder;
                            if (parent.path === '/') {
                                CollectionService.GetAllCollections.get({
                                    type: parent.type.toUpperCase(),
                                    limit: scope.collectionsPerPage,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    paginated: true
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.collections && result.collections.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.collections);
                                    }
                                    parent.totalCollections = result.totalCollections ? result.totalCollections : 0;
                                });
                            } else {
                                var pcid = parent.cid ? parent.cid : parent.xid;
                                CollectionService.GetCollectionContent.get({
                                    cid: pcid,
                                    fol: true,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    limit: scope.collectionsPerPage
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.contents && result.contents.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.contents);
                                    }
                                    parent.totalCollections = result.totalContents ? result.totalContents : 0;
                                });
                            }
                        }
                    };

                    scope.setExpandedFolder = function(parent, $event, addChildColumn){
                        scope.searchEnabled = false;
                        if(parent.path === '/'){
                            setOrigin(parent);
                        } else {
                            selectFolder(parent, $event);
                        }
                        if(addChildColumn) {
                            scope.folderColumns.push(1);
                        }
                        scope.expandedFolder = parent;
                        var pcid = parent.cid ? parent.cid : parent.xid;
                        getChildFolders(pcid, $event);
                        $timeout(function () {
                            var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                            var newleft = (currentleft - 100) + '%';
                            $('.folder-column').css( "left", newleft );
                        }, 0, false);
                    };

                    var setOrigin = function(parent){
                        origin = parent;
                    };

                    // TODO refactor if possible
                    scope.getParentFolders = function($event){

                        var currentleft = scope.folderColumns.length * 100 * -1;
                        var newleft = (currentleft + 100) + '%';
                        $('.folder-column').css( "left", newleft );

                        scope.folderColumns.pop();

                        // The home screen will be shown. There is nothing else to do here.
                        if(scope.expandedFolder.path === '/'){
                            scope.showBackButton = false;
                            return;
                        }

                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);

                        if(pcid === '101' || pcid === '104' || pcid === '100'){
                            if($state.params.collectionId && $state.params.collectionId !== "000") {
                                scope.showBackButton = false;
                            } else if((origin && origin.type.toLowerCase() === 'course') || (!origin && pcid === '101')){
                                scope.expandedFolder = scope.parentFolders[0];
                                pcid = scope.expandedFolder.cid;
                            } else if((origin && origin.type.toLowerCase() === 'protected') || (!origin && pcid === '104')){
                                scope.expandedFolder = scope.parentFolders[1];
                                pcid = scope.expandedFolder.cid;
                            } else if((origin && origin.type.toLowerCase() === 'channel') || (!origin && pcid === '100')){
                                scope.expandedFolder = scope.parentFolders[2];
                                pcid = scope.expandedFolder.cid;
                            }
                            getChildFolders(pcid, $event);
                            scope.selectedFolder = false;
                        } else {
                            var parentType = 'COURSE';

                            if(scope.expandedFolder.path.startsWith("/104")) {
                                parentType = 'PROTECTED';
                            } else if(scope.expandedFolder.path.startsWith("/100")) {
                                parentType = 'CHANNEL';
                            }

                            CollectionService.GetCollection.get({
                                cid: pcid,
                                type: parentType
                            }, function (result) {
                                scope.showBackButton = true;
                                if(scope.folderColumns.length){
                                    scope.setExpandedFolder(result, $event, false);
                                } else {
                                    scope.setExpandedFolder(result, $event, true);
                                }
                            });
                        }
                    };

                    var showChildFolders = function (children, $event) {
                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);
                        if($state.params.collectionId && $state.params.collectionId !== "000") {
                            scope.showBackButton = ['100', '101', '104'].indexOf(pcid) === -1;
                        } else {
                            scope.showBackButton = true;
                        }
                        scope.childFolders = [].concat(children);
                    };

                    var selectFolder = function (folder, event) {
                        scope.selectedFolder = folder;
                        if (scope.selectedFolder.cid) {
                            scope.destinationCollectionIdChanged = scope.zoomfile.item[0].collectionId === scope.selectedFolder.cid;
                        }
                        if (scope.selectedFolder.xid) {
                            scope.destinationCollectionIdChanged = scope.zoomfile.item[0].collectionId === scope.selectedFolder.xid;
                        }
                        if(event) {
                            event.stopPropagation()
                        }
                    };

                    scope.getFoldersForPublishing = function () {

                        // Array used by ng-repeat used for folder transition effect
                        scope.folderColumns = [];

                        $('.folder-column').css( "left", "0%" );

                        scope.searchEnabled = false;
                        scope.childFolders = [];
                        scope.folderPath = [];
                        scope.showBackButton = true;
                        scope.expandedFolder = null;
                        scope.searchField = {query: ''};
                        scope.selectedFolder = null;

                        // 000 - collectionId is equivalent to no collectionId
                        if ($state.params.collectionId && $state.params.collectionId !== "000") {
                            CollectionService.GetCollection.get({
                                cid: $state.params.collectionId,
                                type: 'COURSE'
                            }, function (result) {
                                scope.setExpandedFolder(result, undefined, true);
                            });
                        } else {
                            scope.parentFolders = [
                                {
                                    title: 'Courses',
                                    cid: '101',
                                    type: 'course',
                                    acl: 'RW',
                                    path: '/'
                                },
                                {
                                    title: 'Collections',
                                    cid: '104',
                                    type: 'protected',
                                    acl: 'RW',
                                    path: '/'
                                },
                                {
                                    title: 'Channels',
                                    cid: '100',
                                    type: 'channel',
                                    acl: 'RW',
                                    path: '/'
                                }
                            ];
                        }
                    };

                    scope.publishFile = function () {
                        var fileToBePublished = scope.zoomfile;
                        fileToBePublished.publishLocation = scope.selectedFolder;
                        var collectionId = fileToBePublished.publishLocation.cid ? fileToBePublished.publishLocation.cid : fileToBePublished.publishLocation.xid,
                            path = fileToBePublished.publishLocation.path;
                        // individual recording first pass
                        $.each(fileToBePublished.item, function(k, file) {
                            // not yet imported
                            if ((file.importedText === 'Not Imported' || file.importedText === 'Canceled') && !fileToBePublished.moveAsset) {
                                // call import with as either batch or single recording
                                scope.importZoomRecordingsRequest = new SchedulerService.ImportZoomRecordings.get({
                                    id: file.importId,
                                    meetingId: file.id,
                                    cid: collectionId,
                                    displayInBottomSheet: file.displayInBottomSheet
                                });
                            }
                            // currently importing or has been imported (i.e. there's a basefile)
                            else if ((file.baseFileId) || file.importedText === 'Uploading') {
                                if (!fileToBePublished.moveAsset) {
                                    // set destination and (if status is READY for publish, it will publish as well)
                                    var baseFileResource = new BaseFileService.Destination({
                                        id: file.baseFileId,
                                        fileId: file.fileId,
                                        collectionId: scope.$parent.parent.cid,
                                        destinationCollectionId: collectionId,
                                        meetingUuid: file.uuid
                                    });
                                    baseFileResource.$save(function (response) {
                                    }, function () {
                                        file.errors.push({
                                            id: 'pue' + Date.now(),
                                            msg: UploadErrors.PUBLISH_FILE.formatMessage({name: file.name})
                                        });
                                    });
                                }
                                else {
                                    // move an already published asset
                                    var baseFileResource = new BaseFileService.MoveAsset({
                                        id: file.baseFileId,
                                        fileId: file.fileId,
                                        collectionId: file.collectionId,
                                        destinationCollectionId: collectionId
                                    });
                                    baseFileResource.$save(function (response) {
                                    }, function () {
                                        file.errors.push({
                                            id: 'pue' + Date.now(),
                                            msg: UploadErrors.PUBLISH_FILE.formatMessage({name: file.name})
                                        });
                                    });
                                }
                            }
                            else {
                                // invalid state, error out.
                                alert('An error occurred. Please try again.');
                            }
                        });
                        scope.closeFolderSelectionModal();
                    };

                    scope.checkForSpace = function (item, isChild, event) {
                        if (event.keyCode === 32) {
                            // Ensures My Courses/ Channels doesn't get selected
                            if (!isChild && ['100', '101', '104'].indexOf(item.cid) > -1) {
                                return;
                            }
                            selectFolder(item, event);
                        } else if (event.keyCode === 13) {
                            scope.setExpandedFolder(item, event, true);
                        }
                    };

                    scope.checkForEnter = function (event) {
                        if (event.keyCode === 13) {
                            scope.searchForFolder();
                        }
                    };


                    scope.searchForFolder = function () {
                        if(scope.searchField.query) {
                            scope.searchTerm = scope.searchField.query;
                            scope.searchEnabled = true;
                            $('.folder-column').css("left", "0%");
                            scope.folderColumns = [1];
                            scope.currentPage = 1;

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = [].concat(result.collections);
                                } else {
                                    scope.childFolders = [];
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                            });

                            $timeout(function () {
                                var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                                var newleft = (currentleft - 100) + '%';
                                $('.folder-column').css("left", newleft);
                            }, 0, false);
                        } else {
                            scope.cancelSearch();
                        }
                    };

                    scope.cancelSearch = function() {
                        scope.getFoldersForPublishing();
                    };

                    $(document).ready(function () {
                        $("#zoomImportTopic").change(function() {
                          alert( "Handler for .change() called." );
                        });
                    });

                    scope.$watch('zoomfile.publishTime', function(){
                        if(scope.zoomfile){
                            if (scope.zoomfile.moveAsset) {
                                scope.collectionPath = '';
                                CollectionService.GetCollection.get({
                                    cid: scope.zoomfile.item[0].collectionId,
                                    type: 'COURSE'
                                }, function (result) {
                                    scope.collectionTitle = result.title;
                                    var pathArr = result.path.split('/');
                                    if (pathArr.length > 2) {
                                        var pathModified = pathArr.slice(2, pathArr.length);
                                        var arr = [];
                                        var useEllipses = false;
                                        if (pathModified.length > 3) {
                                            useEllipses = true;
                                        }
                                        console.log('pathModified: ', pathModified, pathModified.length);
                                        $.each(pathModified, function (k, v) {
                                            CollectionService.GetCollection.get({
                                                cid: v,
                                                type: 'COURSE'
                                            }, function (newRes) {
                                                var addition = newRes.title + ' > ';
                                                if (k >= 2 && useEllipses) {
                                                    if (k == 2) {
                                                        addition = ' ... > '
                                                    }
                                                    else {
                                                        addition = '';
                                                }
                                                }
                                                scope.collectionPath = addition + scope.collectionPath;
                                                console.log(k, pathModified.length, scope.collectionPath);
                                            });
                                        });
                                    }
                                });

                                console.log('scope.collectionPath: ', scope.collectionPath);
                            }
                            scope.getFoldersForPublishing();
                            $('#publisher-topic').attr('data-original-title', scope.zoomfile.isBatch ? scope.zoomfile.topic : scope.zoomfile.item[0].topic);
                            $('[data-toggle="tooltip"]').tooltip();
                        }
                    });

                }
            }
        }
    }]);
